export const locations = [
	{
		storeId: 1,
		name: 'Navy Pier',
		address: '700 E Grand Ave, Chicago, IL',
		phone: '(312) 288-8783',
		location: {
			coordinates: [41.891891, -87.60836],
		},
	},
	{
		storeId: 2,
		name: 'Prudential Plaza',
		address: '130 E Randolph St, Chicago, IL',
		phone: '(312) 616-1200',
		location: {
			coordinates: [41.88507, -87.62311],
		},
	},
	{
		storeId: 3,
		name: 'Central Loop',
		address: '223 W Jackson Blvd, Chicago, IL',
		phone: '(312) 583-9400',
		location: {
			coordinates: [41.878, -87.6341],
		},
	},
	{
		storeId: 4,
		name: 'South Loop',
		address: '1340 S Michigan Ave, Chicago, IL',
		phone: '(312) 842-1100',
		location: {
			coordinates: [41.891891, -87.60836],
		},
	},
	{
		storeId: 5,
		name: 'Greektown',
		address: '815 W Van Buren St, Chicago, IL',
		phone: '(312) 421-1221',
		location: {
			coordinates: [41.87628, -87.64805],
		},
	},
	{
		storeId: 6,
		name: 'Pilsen',
		address: '1401 W 18th St, Chicago, IL',
		phone: '(312) 265-0243',
		location: {
			coordinates: [41.85777, -87.66168],
		},
	},
];
